import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../../store/store-provider';
import PollEntity from '../../../store/polls-store/poll-entity';
import PollDetailsHeader from './poll-details-components/poll-details-header';
import PollVotesList from '../shared/poll-votes-list';
import { MIDDLE_SIZE_BREAKPOINT } from '../../../constans/responsive-break-points';
import './poll-details.scss';

interface IProps {
  poll: PollEntity;
}

const PollDetails: FC<IProps> = ({ poll }) => {
  const { pollsStore, podiumInfoStore } = useStore();
  const {
    getPollChoisesList,
    changePollStatus,
    isEllipsisMenuOpened,
    setShouldShowEllipsisMenu,
    toggleManagePollModal,
    setShouldShowDeleteModal,
    setShouldShowResetModal,
    setShouldShowFullScreen,
    setShouldShowAddResultsSlideModal,
    setActiveTab,
    isOnePollOpened,
    setIsFullScreenModeSafari,
  } = pollsStore;
  const isMobile = podiumInfoStore.isResolutionBreakPointActive(MIDDLE_SIZE_BREAKPOINT);

  return (
    <div className='poll-details'>
      <PollDetailsHeader
        poll={poll}
        changePollStatus={changePollStatus}
        isEllipsisMenuOpened={isEllipsisMenuOpened}
        setShouldShowEllipsisMenu={setShouldShowEllipsisMenu}
        toggleManagePollModal={toggleManagePollModal}
        setShouldShowDeleteModal={setShouldShowDeleteModal}
        setShouldShowResetModal={setShouldShowResetModal}
        setShouldShowFullScreen={setShouldShowFullScreen}
        setShouldShowAddResultsSlideModal={setShouldShowAddResultsSlideModal}
        setActiveMobileTab={setActiveTab}
        isMobile={isMobile}
        isOnePollOpened={isOnePollOpened}
        setIsFullScreenModeSafari={setIsFullScreenModeSafari}
      />

      <PollVotesList
        responses={poll.getFilteredResponses()}
        countVotes={poll.countVotes}
        getPollChoisesList={getPollChoisesList}
        selectedPollId={poll.getId()}
      />
    </div>
  );
};

export default observer(PollDetails);
